module.exports = {
      id: "gn-reach-icon-usage",
      viewBox: "0 0 159 50",
      url: __webpack_public_path__ + "svg-sprite-fc82091df19536c1119ee4fda7ed47d6.svg#gn-reach-icon",
      toString: function () {
        return this.url;
      }
    }